<template>
  <fragment>
    <div class="text-center mt-2" v-if="variablesLoading">
      <b-spinner
        variant="success"
        style="width: 2rem; height: 2rem;"
        label="Large Spinner"
      />
    </div>
    <template v-else>
      <vue-bootstrap-typeahead
        v-if="!selectedVariable"
        ref="variableSelector"
        class="mt-2"
        :data="variables"
        :serializer="
          (v) =>
            `Q${v.question.id}: ${v.question.prompt} / V${v.id}: ${v.input_label}`
        "
        @hit="onVariableSelect"
        placeholder="Type part of question prompt or variable input label..."
      >
        <template slot="suggestion" slot-scope="{ data }">
          <variable-display :variable="data" />
        </template>
      </vue-bootstrap-typeahead>
      <variable-display v-else class="mt-2" :variable="selectedVariable">
        <i
          slot="remove-icon"
          class="mdi mdi-close-circle-outline size-medium phairify-color-red"
          @click="$emit('set-visibility-condition', null)"
        />
      </variable-display>
    </template>
  </fragment>
</template>

<script>
import GetVariableConditionItemsMixin from '@/mixins/GetVariableConditionItemsMixin';
import VariableDisplay from '@/components/VariableDisplay';
import VueBootstrapTypeahead from 'vue-typeahead-bootstrap';
import { CONDITION_VARIANTS } from '@/store';

export default {
  name: 'VariableConditionSelector',
  mixins: [GetVariableConditionItemsMixin],
  components: {
    VariableDisplay,
    VueBootstrapTypeahead,
  },
  props: {
    condition: Object,
  },
  computed: {
    variables: function () {
      return this.$store.getters.variablesVisibilityConditionItems;
    },
    conditionVariableId: function () {
      return this.condition && this.condition.variable_id;
    },
    selectedVariable: function () {
      return this.variables.find(({ id }) => id === this.conditionVariableId);
    },
    variablesLoading: function () {
      return this.$store.state.conditionVariables.loading;
    },
  },
  methods: {
    onVariableSelect: function (variable) {
      this.$emit('set-visibility-condition', {
        variant: CONDITION_VARIANTS.VISIBILITY,
        variable_id: variable.id,
      });
    },
  },
};
</script>

<style scoped>
i.mdi.mdi-close-circle-outline {
  position: absolute;
  top: calc(50% - 22px);
  right: 0;
}
</style>
